module.exports = __webpack_public_path__ + "img/scene-storage.c19f9ab2.jpg";